import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchCustomerSubscription, removeSeatsForPlgExternal2, startCancellationProcessForPlgExternal2 } from './customer.thunk';
import { RootState } from '../rootReducer';
import { Features } from '../../featureToggles/features';
import { BlockedByFeature, notAvailablePropExceptIn } from '../../featureToggles/features/utils';

export interface ISubscription {
  card: {
    lastFourDigits: string;
    brand: string;
  } | null;
  amount: number;
  status: string;
  description: string;
  paymentCadence: string;
  licensesQty: number;
  id: string;
}

export interface SubscriptionState {
  requestedSubscription: boolean;
  loading: boolean;
  error: string | null;
  data: ISubscription | null;
  cancelling: boolean;
  updatingSubscription: boolean;
}

export interface ICard {
  lastFourDigits: string;
  brand: string;
}

const getSubscriptionCard = (state: RootState): ICard | null => state.subscription.data?.card || null;
const isCancelling = (state: RootState): boolean | typeof BlockedByFeature => {
  return notAvailablePropExceptIn({ expected: state.subscription.cancelling, availableIn: [Features.PlgExternal2] });
};

export const selectors = {
  getSubscriptionCard,
  isCancelling
};

const initialState: SubscriptionState = {
  requestedSubscription: false,
  loading: false,
  error: null,
  data: null,
  cancelling: false,
  updatingSubscription: false
};

const extraReducers = {
  [fetchCustomerSubscription.pending.type]: (state: SubscriptionState): void => {
    state.loading = true;
    state.error = null;
    state.requestedSubscription = false;
    state.data = null;
  },
  [fetchCustomerSubscription.rejected.type]: (state: SubscriptionState, action: PayloadAction<string>): void => {
    state.loading = false;
    state.error = action.payload;
    state.requestedSubscription = false;
    state.data = null;
  },
  [fetchCustomerSubscription.fulfilled.type]: (state: SubscriptionState, action: PayloadAction<ISubscription>): void => {
    state.loading = false;
    state.error = null;
    state.requestedSubscription = true;
    state.data = action.payload;
  },
  [startCancellationProcessForPlgExternal2.pending.type]: (state: SubscriptionState): void => {
    state.cancelling = true;
  },
  [startCancellationProcessForPlgExternal2.fulfilled.type]: (state: SubscriptionState): void => {
    state.cancelling = false;
  },
  [startCancellationProcessForPlgExternal2.rejected.type]: (state: SubscriptionState): void => {
    state.cancelling = false;
  },
  [removeSeatsForPlgExternal2.rejected.type]: (state: SubscriptionState): void => {
    state.updatingSubscription = false;
  },
  [removeSeatsForPlgExternal2.fulfilled.type]: (state: SubscriptionState): void => {
    state.updatingSubscription = false;
  },
  [removeSeatsForPlgExternal2.pending.type]: (state: SubscriptionState): void => {
    state.updatingSubscription = true;
  }
};

const SubscriptionSlice = createSlice({
  name: 'fetchCustomer',
  initialState,
  reducers: {},
  extraReducers
});

export const SubscriptionReducer = SubscriptionSlice.reducer;
